<template>
  <div id="press_releases" class="position-relative">
    <div class="random-cont">
      <random-section cardType="news" :error="newsError" :show="show" :data="pressSlider" v-if="staticCard" style="min-height: 500px" />
      <SliderSection cardType="news" sectionType="press" id="cards-slider" sliderHolder="pressReleases" :data="pressSlider" :obj="pressNewsRepo" method="get" v-if="slider" />
    </div>
    <div v-if="loadingYears" class="full-screen">
      <Loader />
    </div>
    <div v-if="errorYears" class="full-screen">
      <Error class="pb-12" />
    </div>
    <div class="position-relative" v-if="yearFetched" style="background: #F2F2F2 !important;">
      <div class="upper-layer"></div>
      <template>
        <vue-simple-select :style=" options.length === 0 ? { pointerEvents: 'none' } : ''" :key="key" class="year-selector"
                           v-model="selected"
                           :options="options"
        />
      </template>
      <div  v-if="tabs.length > 0" id="inner-tab">
        <div class="tabsContainer tabs">
          <v-tabs
            v-model="tab"
            background-color="#FFFFFF"
            color="#1D1D1D"
            grow
            centered
            show-arrows
            :class="[this.$lang === 'ar' ? 'left-dir' : 'left-dir', 'financialTab innerTabContainer releases']"
          >
            <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
            <v-tab ref="tab" v-for="(item, index) in tabs" :disabled="Number(selected.value) === currentYear && index > currentMonth && true" :key="index">
              {{item}}
            </v-tab>
          </v-tabs>
        </div>
        <v-tabs-items v-model="tab" :touchless="true">
          <div v-if="sliderRefresh">
            <v-tab-item v-for="(item, i) in tabs" :key="i">
              <SliderSection :obj="pressSliderRepo" method="getParamsById" :extraUrl="`${i + 1}/${selected.value}`" sliderHolder="pressReleases" id="press-social-card" :key="sliderKey" :data="info[tab]" />
            </v-tab-item>
          </div>
        </v-tabs-items>
      </div>
    </div>
    <mtn-app />
  </div>
</template>

<script>
import RandomSection from '../../components/sections/RandomCards'
import MtnApp from '../CommercialApp'
import arrow from '../../assets/icons/yellow-arrow.svg'
import VueSimpleSelect from 'vue-simple-custom-select'
import PressReleaseNewsRepository from '../../repositories/PressReleaseNewsRepository'
import PressReleaseYearsRepository from '../../repositories/PressReleaseYearsRepository'
import SliderSection from '../../components/sections/SliderSection'
import PressReleaseSliderRepository from '../../repositories/PressReleaseSliderRepository'
import $ from 'jquery'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'PressReleases',
  components: { MtnApp, RandomSection, VueSimpleSelect, SliderSection, Loader, Error },
  data () {
    return {
      // background: image,
      allOptions: [],
      tab: 0,
      tabs: [],
      lang: this.$lang,
      test: false,
      pressNewsRepo: new PressReleaseNewsRepository(),
      pressYearsRepo: new PressReleaseYearsRepository(),
      pressSliderRepo: new PressReleaseSliderRepository(),
      arrow: arrow,
      selected: { label: '', value: '' },
      options: [],
      info: [{
        sliderType: 'press&social',
        main: { sectionId: 'press_releases', cardType: 'press-releases', title: this.$t('pressCenter.title'), description: this.$t('pressCenter.desc'), image: '' },
        slider: []
      }],
      pressSlider: {
        sliderType: 'cardsMiniSlider',
        main: { sectionId: 'press_releases_slider', cardType: 'press_releases_slider', title: this.$t('pressCenter.title'), description: this.$t('pressCenter.desc'), image: '' },
        slider: [{ title: '', description: '', icon: '', styles: 'main' },
          { title: '', description: '', icon: '', styles: 'second' },
          { title: '', description: '', icon: '', styles: 'third' }]
      },
      fetched: false,
      yearFetched: false,
      size: 4,
      key: 0,
      show: false,
      newsError: false,
      slider: false,
      staticCard: true,
      requestedTabs: [],
      sliderKey: 0,
      loadingYears: false,
      errorYears: false,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      sliderRefresh: false
    }
  },
  watch: {
    async tab (val) {
    },
    async selected (val) {
      this.info = []
      const temp = []
      for (let i = 0; i < this.allOptions.length; i++) {
        if (this.allOptions[i].value !== this.selected.value) {
          temp.push(this.allOptions[i])
        }
      }
      this.options = []
      this.options = [...temp]
      for (let i = 0; i < 12; i++) {
        this.info.push({
          sliderType: 'press&social',
          main: { sectionId: 'press_releases', cardType: 'press-releases', title: this.$t('pressCenter.title'), description: this.$t('pressCenter.desc'), image: '' },
          slider: []
        })
      }
      this.tab = 0
      this.sliderKey++
      this.sliderRefresh = false
      setTimeout(() => {
        this.sliderRefresh = true
      })
    }
  },
  mounted () {
    this.arabic()
    this.$watch(() => {
      return this.$store.state.tab
    }, (val) => {
      if (this.$lang !== 'ar') {
        $('.tabsContainer').removeClass('arabicTabContainer')
        $('.innerTabContainer .v-tab').css('transform', 'rotateY(0deg)')
      }
    })
    window.addEventListener('resize', () => {
      this.hideSlider()
    })
  },
  created () {
    this.$store.state.prevRoute = this.$lang === 'ar' ? 'أخبار' : 'News'
    this.handlePressReleaseNews()
    this.handleYears()
    for (let i = 0; i < 12; i++) {
      this.info.push({
        sliderType: 'press&social',
        main: { sectionId: 'press_releases', cardType: 'press-releases', title: this.$t('pressCenter.title'), description: this.$t('pressCenter.desc'), image: '' },
        slider: []
      })
    }
    this.hideSlider()
  },
  methods: {
    hideSlider () {
      if (window.innerWidth > 1100) {
        this.staticCard = true
        this.slider = false
      } else if (window.innerWidth <= 1100) {
        this.staticCard = false
        this.slider = true
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.circle-background').css('transform', 'rotate(0deg)')
        $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.innerTabContainer .v-tab').css('transform', 'rotateY(180deg)')
        $('#press_releases .random-cont').addClass('ar')
      } else {
        $('#press_releases .random-cont').addClass('en')
      }
    },
    async handlePressReleaseNews () {
      try {
        const response = await this.pressNewsRepo.get()
        if (response.status === 200) {
          this.pressSlider.slider = []
          for (let i = 0; i < response.data.length; i++) {
            this.pressSlider.slider.push({ id: response.data[i].id, title: response.data[i].title, description: response.data[i].html, icon: gc.baseUrl + '/customerCare' + response.data[i].newsMedia[0].media, styles: i === 0 ? 'main' : i === 1 ? 'second' : 'third' })
          }
          this.show = true
        } else {
          this.newsError = true
          this.show = false
        }
      } catch (e) {
        this.newsError = true
        this.show = false
        console.log(e)
      }
    },
    async handleYears () {
      this.loadingYears = true
      try {
        const response = await this.pressYearsRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.options.push({ label: 'Year ' + response.data[i], value: response.data[i] })
            this.allOptions.push({ label: 'Year ' + response.data[i], value: response.data[i] })
          }
          this.tabs = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
          this.selected = { label: 'Year ' + response.data[0], value: response.data[0] }
          this.key++
          this.yearFetched = true
          const temp = []
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].value !== this.selected.value) {
              temp.push(this.options[i])
            }
          }
          this.options = []
          this.options = [...temp]
          setTimeout(() => {
            this.arabic()
            if (this.options.length === 0) {
              $('#press_releases svg.w-6.h-6.vue-simple-select-icon').css('display', 'none')
            }
          })
        } else {
          this.errorYears = true
          this.loadingYears = false
        }
      } catch (e) {
        this.errorYears = true
        this.loadingYears = false
        return e
      }
      this.loadingYears = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
#press_releases {
  background-image: linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
}
//#press_releases .random-cont {
//  background: url("../../assets/images/back1.png");
//}
#press_releases .random-cont.ar {
  background: url("../../assets/images/circles-back-ar.png") no-repeat right;
}
#press_releases .random-cont.en {
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}
.hide{
  display: none !important;
}
.upper-layer{
  height: 100%;
  width: 100%;
  position: absolute;
}
#press_releases {
  margin-top: 155px;
  //background-image: $--gray-gradient;
  //background: rgb(242,242,242);
  .full-screen{
    min-height: 500px;
    background: rgb(242, 242, 242)!important;
    .loader,
    .error-container{
      min-height: 500px !important;
    }
  }
}
.selector-container {
  background: #F2F2F2;
  position: relative;
}
.year-selector{
  width: 110px;
  display: block;
  margin: 0 auto;
  font-size: 18px;
}
</style>
<style lang="scss">
.vue-simple-select-container .vue-simple-select-dropdown{
  z-index: 10;
}
#press_releases {
  .tabs{
    height: 50px;
  }
  .vue-simple-select-container .vue-simple-select-dropdown{
    top: 80%;
  }
  .v-tabs{
    background: rgba(250,250,250,0.8)!important;
  }
  .vue-simple-select-container.year-selector{
    border: none !important;
    padding: 10px 0;
    span.vue-simple-select-selected-option{
      padding: 0 8px;
    }
  }
  ul.vue-simple-select-list{
    font-size: 14px;
  }
}
.v-tabs-slider-wrapper{
  height: 4px !important;
  bottom: -2px !important;
}
.v-tab.v-tab--disabled.disabled{
  cursor: not-allowed !important;
}
.v-tab.v-tab--disabled{
  pointer-events: auto;
  cursor: not-allowed;
}
</style>
<style lang="scss" scoped>
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";
.arabicTabContainer{
  direction: ltr;
  transform: rotateY(180deg);
}
.v-tabs {
  /*height: 50px;*/
  //background: #ffffff!important;
}
.v-tabs, .v-tabs-bar {
  /*height: 50px!important;*/
  color: rgba(29, 29, 29, 0.7) !important;
}
/*.innerTabContainer{*/
/*  padding: 0 4vw;*/
/*  border: 1px white solid;*/
/*}*/
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: rgba(29, 29, 29, 1) !important;
  font-size: 12px;
}
.releases .v-tab--active {
  color: $--yellow !important;
  font-family: Mtn-bold;
  font-style: italic;
  font-size: 12px !important;
}
#press_releases{
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border-bottom: none !important;
  }
  .v-tab{
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
}
</style>
